import React, { FC, useState, useContext } from 'react';
import { DecisionUploadForm } from './DecisionUploadForm';
import { DecisionUploadSuccess } from './success/DecisionUploadSuccess';
import { DecisionUploadContext } from '../DecisionUploadContext';

export const DecisionUploadFormContainer: FC = () => {
  const [success, setSuccess] = useState(false);
  const { jurisdictionsKeys } = useContext(DecisionUploadContext);

  const handleSuccess = (value?: boolean) => {
    setSuccess(!!value);
  };

  return success ? (
    <DecisionUploadSuccess reset={handleSuccess} />
  ) : (
    <DecisionUploadForm
      handleSuccess={handleSuccess}
      jurisdictionsKeys={jurisdictionsKeys}
    />
  );
};
